export default __webpack_public_path__ + "static/media/halfstar.5f7ece7e.svg";